import { render, staticRenderFns } from "./PurchaseLogsCard.vue?vue&type=template&id=9c240772&"
import script from "./PurchaseLogsCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseLogsCard.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseLogsCard.vue?vue&type=style&index=0&id=9c240772&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports